//跨域代理前缀
// const API_PROXY_PREFIX='/api'
const BASE_URL = process.env.VUE_APP_API_BASE_URL
module.exports = {
  API:BASE_URL,
  LOGIN: `${BASE_URL}/login`,
  ROUTES: `${BASE_URL}/routes`,
  GOODS: `${BASE_URL}/goods`,
  GOODS_COLUMNS: `${BASE_URL}/columns`,
  USER: `${BASE_URL}/user`,
  ROTATION: `${BASE_URL}/rotation`,
  BANNER: `${BASE_URL}/rotation`,
  ORGANIZATION: `${BASE_URL}/organization`,
  ROLE: `${BASE_URL}/role`,
  MENU: `${BASE_URL}/menu`,
  AUTH: `${BASE_URL}/authority`,
  LEAVE_SCHOOL: `${BASE_URL}/leavingschool`,
  MATERIAL: `${BASE_URL}/leavingschool/material`,
  STU_MATERIAL: `${BASE_URL}/leavingschool/GraduationStudentMaterial`,
}
